<template>
  <div>
    <div class="SlbMonitor-title">
      <div>{{ $t("alarms.network.loadBalancing.loadBalancing") }}</div>
      <div>
        <Button
          type="primary"
          @click="addOrUpdateHandle"
          v-hasPermission="['network:slbMonitor:add_alert_rule']"
          >{{ $t("alarms.network.loadBalancing.addLBAlarm") }}</Button
        >
        <add-or-update-slb-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-slb-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" v-model="currentTab" :animated="false">
        <TabPane
          :label="$t('alarms.network.loadBalancing.loadBalancing')"
          name="tabDatabase"
        >
          <table-slb @changeCurrentTab="changeCurrentTab"></table-slb>
        </TabPane>
        <TabPane :label="$t('alarms.common.alertRule')" name="tabAlertRule">
          <div class="SLBMonitor-top">
            <slb-warning-alert-rule-search></slb-warning-alert-rule-search>
          </div>
          <table-slb-warning></table-slb-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import TableSlb from "../slb/TableSlb";
import AddOrUpdateSlbWarning from "../slb/AddOrUpdateSlbWarning";
import SlbWarningAlertRuleSearch from "../slb/SlbWarningAlertRuleSearch";
import TableSlbWarning from "../slb/TableSlbWarning";
const tableSlbWarning = TableSlbWarning;
export default {
  name: "SlbMonitor",
  components: {
    TableSlb,
    AddOrUpdateSlbWarning,
    SlbWarningAlertRuleSearch,
    TableSlbWarning,
  },
  data() {
    return {
      currentTab: "",
      addOrUpdateVisible: false,
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function () {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    changeCurrentTab: function (row, monitorIndex) {
      this.currentTab = "tabAlertRule";
      eventBus.$emit("databaseId", row.databaseId);
      eventBus.$emit("monitorIndex", monitorIndex);
      eventBus.$emit("typeId", 1);
      // eventBus.$emit('stateId', 0);
      tableSlbWarning.methods.showAll();
    },
  },
};
</script>

<style scoped>
.SlbMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.SlbMonitor-title > div:nth-child(1) {
  float: left;
}
.SlbMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/slb/SlbMonitor.vue